import * as Yup from 'yup'

const schema = Yup.object().shape({
  name: Yup.string().required('Required'),
})

const documentValidation = {
  async validator({ field }, value) {
    await schema.validateSyncAt(field, { [field]: value })
  },
}

export { documentValidation }
